/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbrisk": {
        "nested": {
          "action": {
            "nested": {
              "ActionType": {
                "values": {
                  "UNKNOWN_ACTION_TYPE": 0,
                  "CARD_ORDER": 1,
                  "MOBILE_CHECK_DEPOSIT": 2,
                  "DIGITAL_WALLET_ACTIVATION": 3,
                  "VIEW_PAN": 4,
                  "CARD_ACTIVATION": 5,
                  "ISSUE_CHECK": 6,
                  "RESET_PIN": 7,
                  "INSTANT_TRANSFER": 8,
                  "SQ_CARD_DISPUTE": 9,
                  "VIEW_ACCOUNT_AND_ROUTING_NUMBER": 10,
                  "VIEW_PAY_BILL_DATA": 11,
                  "STANDARD_TRANSFER": 12,
                  "PAPER_CASH_DEPOSIT": 13,
                  "INSTANT_ACCESS_PREFUNDING": 14,
                  "BTC_CONVERSIONS": 15,
                  "ADD_FUNDS": 16
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbrisk?.nested?.action?.nested?.ActionType) {
  $root.addJSON(jsonData);
}

/**
 * This must be kept in sync with the ActionType enum defined in declined_action.proto
 *
 * SOURCE ActionType @ squareup/bbrisk/action.proto at 10:1
 */
export const ActionType = $root.lookupEnum('squareup.bbrisk.action.ActionType').values;